//Modules
import React, { useContext } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Icon } from '@iconify/react'
import * as urlSlug from 'url-slug'

//Utils
import { newsContext } from '../../utils/UtilContext'

//Components
import NewsCache from './NewsCache'

const { REACT_APP_IPBNEWS_URL_IMG, REACT_APP_IPBNEWS_FILTER_STRUCTURES } = process.env

const News = ({ size }) => {
    const { news, loading, isError } = useContext(newsContext)

    let { pathname } = useLocation()
    const lang = pathname.substring(1,3)

    let newsFiltered = ((!loading || news !== null) && Array.isArray(news)) &&
        news.filter((newsItem) => {   
            if(newsItem.estrutura)
                return (newsItem.estrutura.includes(`${REACT_APP_IPBNEWS_FILTER_STRUCTURES}`))
            else
                return newsItem
        })

    return (
        <>
            {((!loading || newsFiltered !== null) && Array.isArray(newsFiltered)) ? 
                <>                
                    <div className="newsCardsHome">                   
                        {newsFiltered.slice(0,size).map((newsItem) => (                              
                            <div key={newsItem.press_noticia_id} className="card mt-sm-3">
                                
                                <Link to={lang === "pt" ?
                                    "/pt/noticias/"+urlSlug.convert(`${newsItem.titulo} ${newsItem.press_noticia_id}`)
                                    : "/en/news/"+urlSlug.convert(`${newsItem.titulo} ${newsItem.press_noticia_id}`)
                                } state={{from: pathname}}>
                                    <div className="cardImg">
                                        <img src={`${REACT_APP_IPBNEWS_URL_IMG}${newsItem.foto}`} alt="Foto"/>
                                    </div>
                                    <div className="card-body">
                                        <div className="card-title">
                                            <p>{newsItem.titulo}</p>
                                        </div>                                
                                    </div>
                                </Link>
                                <div className="card-date">
                                    <span>
                                        {new Date(newsItem.data).toLocaleDateString("pt-PT", {
                                            year: "numeric",
                                            month: "long",
                                            day: "numeric",
                                        })}
                                    </span>
                                </div>
                            </div>
                        ))}                        
                    </div>                        
                    <div className="moreNews">
                        {lang === "pt" ?
                        <Link to={`/pt/noticias`}>Todas as Notícias</Link>
                        :
                        <Link to={`/en/news`}>All News</Link>}                        
                    </div>
                </>
                :                 
                <div>
                    {isError || news !== null ?
                        <NewsCache pathname={pathname} size={size} lang={lang} />
                    :
                        <Icon style={{fontSize: '3rem'}} icon="svg-spinners:ring-resize" />
                    }
                </div>                
            }
        </>        
    )

}

export default News